<template>
  <div
    class="d-flex flex-column justify-space-around align-center"
    ref="el"
    :class="{
      flexColumn: isVertical,
      wFull: !isVertical,
    }"
    :style="{
      ...margin,
    }"
  >
    <div
      v-for="i in dots || nOfDots"
      :key="`t-${i}`"
      class="dot"
      :class="{ top, bottom, left, right, vertical }"
      :style="{
        backgroundColor: bgColor,
        width: `${size}px`,
        height: `${size}px`,
      }"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      nOfDots: 6,
    };
  },
  watch: {
    $refs: {
      handler() {
        this.calculateDots();
      },
      deep: true,
      immediate: true,
    },
    size: {
      handler() {
        this.calculateDots();
      },
      immediate: true,
    },
    spaceFactor: {
      handler() {
        this.calculateDots();
      },
      immediate: true,
    },
  },
  methods: {
    calculateDots() {
      const space = this.size * this.spaceFactor;
      const width = this.$refs.el?.offsetWidth || 7 * space;
      const height = this.$refs.el?.offsetHeight || 7 * space;
      const size = this.isVertical ? height : width;
      this.nOfDots = Math.floor(size / space) - 1;
    },
  },
  computed: {
    bgColor() {
      if (this.color) return this.color;
      return this.$vuetify.theme.dark ? "#121212" : "#f2f3f8";
    },
    isVertical() {
      return this.left || this.right || this.vertical;
    },
    margin() {
      if (this.isVertical)
        return {
          margin: `-${this.size / this.spaceFactor}px 0px`,
        };
      return {
        margin: `0px -${this.size / this.spaceFactor}px`,
      };
    },
  },
  mounted() {
    this.calculateDots();
  },
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    size: {
      type: Number,
      default: 30,
    },
    left: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    spaceFactor: {
      type: Number,
      default: 2,
    },
    dots: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.dot {
  border-radius: 50%;
  display: inline-block;
  margin: -100% 0px;
  z-index: 1;
}
.top {
  clip-path: polygon(0% 50%, 0% 100%, 100% 100%, 100% 50%);
}
.bottom {
  clip-path: polygon(0% 0%, 0% 50%, 100% 50%, 100% 0%);
}
.left {
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%, 0% 50%);
}
.right {
  clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
}
.vertical {
  clip-path: circle(50% at 50% 50%);
}
</style>
